(function () {
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var dialog = null;
  var state = null;

  function money(cents) {
    return (cents / 100).toFixed(2).replace('.', ',').replace(',00', '') + ' €';
  }

  function esc(text) {
    var node = document.createElement('div');
    node.textContent = text;
    return node.innerHTML;
  }

  function imageAt(src, width) {
    if (!src) return '';
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + width;
  }

  function isColor(name) {
    return /coul|colo/i.test(name);
  }

  function shownOptions(product) {
    return product.options
      .map(function (option, index) {
        return { name: option.name, values: option.values, index: index };
      })
      .filter(function (option) {
        return option.values.length > 1 && !/ship|exped/i.test(option.name);
      });
  }

  function fits(variant, picks, skip) {
    return Object.keys(picks).every(function (key) {
      return Number(key) === skip || picks[key] == null || variant.options[key] === picks[key];
    });
  }

  function currentVariant() {
    var complete = state.options.every(function (option) {
      return state.picks[option.index] != null;
    });
    if (!complete) return null;
    return (
      state.product.variants.find(function (variant) {
        return variant.available && fits(variant, state.picks);
      }) || null
    );
  }

  function valueIsOn(option, value) {
    return state.product.variants.some(function (variant) {
      return variant.available && variant.options[option.index] === value && fits(variant, state.picks, option.index);
    });
  }

  function send(variantId) {
    return fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json', 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    }).then(function (response) {
      return response.json().then(function (line) {
        if (!response.ok || line.status) throw new Error(line.description || 'Ajout impossible');
        return line;
      });
    });
  }

  function added(line, trigger) {
    var tracking = window.SeoShopifyTracking;
    if (tracking && tracking.handleAddToCartSuccess) tracking.handleAddToCartSuccess(trigger, line);
    else document.dispatchEvent(new CustomEvent('updateCart', { bubbles: true }));
  }

  function ensureDialog() {
    if (dialog) return dialog;
    dialog = document.createElement('dialog');
    dialog.className = 'lc-qa';
    dialog.setAttribute('aria-labelledby', 'LcQaTitle');
    dialog.addEventListener('click', function (event) {
      if (event.target === dialog) {
        dialog.close();
        return;
      }
      if (event.target.closest('[data-qa-close]')) {
        dialog.close();
        return;
      }
      var choice = event.target.closest('[data-qa-value]');
      if (choice && !choice.disabled) {
        var index = Number(choice.dataset.qaIndex);
        state.picks[index] = choice.dataset.qaValue;
        state.error = '';
        settle(index);
        var value = choice.dataset.qaValue;
        paint();
        var again = [].find.call(dialog.querySelectorAll('[data-qa-value]'), function (button) {
          return button.dataset.qaValue === value && Number(button.dataset.qaIndex) === index;
        });
        if (again) again.focus();
        return;
      }
      if (event.target.closest('[data-qa-add]')) submit();
    });
    document.body.appendChild(dialog);
    return dialog;
  }

  function settle(changed) {
    state.options.forEach(function (option) {
      if (option.index === changed) return;
      var pick = state.picks[option.index];
      if (pick != null && !valueIsOn(option, pick)) state.picks[option.index] = null;
    });
  }

  function paint() {
    var product = state.product;
    var variant = currentVariant();
    var shown =
      variant ||
      product.variants.find(function (item) { return item.available && fits(item, state.picks); }) ||
      product.variants.find(function (item) { return item.available; });
    var colorIndex = state.options.filter(function (option) { return isColor(option.name); })[0];
    if (colorIndex && state.picks[colorIndex.index] != null) {
      var withColor = product.variants.find(function (item) {
        return item.options[colorIndex.index] === state.picks[colorIndex.index] && item.featured_image;
      });
      if (withColor) state.image = withColor.featured_image.src;
    }
    var missing = state.options.filter(function (option) { return state.picks[option.index] == null; })[0];
    var hasDeal = shown.compare_at_price > shown.price;
    var html =
      '<div class="lc-qa__box">' +
      '<button class="lc-qa__close" type="button" data-qa-close aria-label="Fermer"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg></button>' +
      '<div class="lc-qa__head">' +
      (state.image ? '<img src="' + esc(imageAt(state.image, 240)) + '" alt="" width="84" height="96">' : '') +
      '<div><h2 id="LcQaTitle">' + esc(product.title) + '</h2><p class="lc-qa__price">' +
      (hasDeal ? '<s>' + money(shown.compare_at_price) + '</s>' : '') +
      '<b' + (hasDeal ? ' class="is-deal"' : '') + '>' + money(shown.price) + '</b>' +
      (hasDeal ? '<span>−' + Math.round(((shown.compare_at_price - shown.price) * 100) / shown.compare_at_price) + ' %</span>' : '') +
      '</p></div></div>';
    state.options.forEach(function (option) {
      var picked = state.picks[option.index];
      html +=
        '<div class="lc-qa__opt" role="group" aria-label="' + esc(option.name) + '"><p>' + esc(option.name) +
        (picked ? ' <span>' + esc(picked) + '</span>' : '') + '</p><div class="' +
        (isColor(option.name) ? 'lc-qa__chips' : 'lc-qa__sizes') + '">';
      option.values.forEach(function (value) {
        var on = valueIsOn(option, value);
        html +=
          '<button type="button" data-qa-value="' + esc(value).replace(/"/g, '&quot;') + '" data-qa-index="' + option.index + '" aria-pressed="' +
          (picked === value) + '"' + (on ? '' : ' disabled') + '>' + esc(value) + (on ? '' : '<small>Épuisé</small>') + '</button>';
      });
      html += '</div></div>';
    });
    html +=
      '<p class="lc-qa__error" role="alert"' + (state.error ? '' : ' hidden') + '>' + esc(state.error || '') + '</p>' +
      '<button class="lc-qa__add" type="button" data-qa-add' + (variant ? '' : ' disabled') + '>' +
      (state.busy ? 'Ajout en cours…' : variant ? 'Ajouter au panier' : 'Choisissez : ' + esc(missing ? missing.name.toLowerCase() : 'une option')) +
      '</button>' +
      '<a class="lc-qa__more" href="' + esc(product.url) + '">Voir la fiche du produit</a>' +
      '</div>';
    var scrollTop = dialog.scrollTop;
    dialog.innerHTML = html;
    dialog.scrollTop = scrollTop;
  }

  function submit() {
    var variant = currentVariant();
    if (!variant || state.busy) return;
    state.busy = true;
    state.error = '';
    paint();
    send(variant.id)
      .then(function (line) {
        var trigger = state.trigger;
        state.busy = false;
        dialog.close();
        added(line, trigger);
      })
      .catch(function (error) {
        state.busy = false;
        state.error = error.message;
        paint();
      });
  }

  function open(product, trigger) {
    var options = shownOptions(product);
    var first = product.variants.find(function (variant) { return variant.available; });
    if (!first) {
      window.location.href = product.url;
      return;
    }
    if (!options.length) {
      send(first.id)
        .then(function (line) { added(line, trigger); })
        .catch(function () { window.location.href = product.url; });
      return;
    }
    state = { product: product, options: options, picks: {}, trigger: trigger, image: product.featured_image, busy: false, error: '' };
    var fileName = function (src) {
      return String(src || '').split('/').pop().split('?')[0];
    };
    var lead =
      product.variants.find(function (variant) {
        return variant.available && variant.featured_image && fileName(variant.featured_image.src) === fileName(product.featured_image);
      }) || first;
    options.forEach(function (option) {
      if (isColor(option.name)) state.picks[option.index] = lead.options[option.index];
    });
    options.forEach(function (option) {
      var on = option.values.filter(function (value) { return valueIsOn(option, value); });
      if (state.picks[option.index] == null && on.length === 1) state.picks[option.index] = on[0];
    });
    ensureDialog();
    paint();
    dialog.showModal();
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-quick-add]');
    if (!trigger) return;
    event.preventDefault();
    if (trigger.classList.contains('is-loading')) return;
    var handle = trigger.dataset.quickAdd;
    trigger.classList.add('is-loading');
    fetch(root + 'products/' + handle + '.js')
      .then(function (response) {
        if (!response.ok) throw new Error('product');
        return response.json();
      })
      .then(function (product) {
        open(product, trigger);
      })
      .catch(function () {
        window.location.href = root + 'products/' + handle;
      })
      .then(function () {
        trigger.classList.remove('is-loading');
      });
  });
})();
